module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "mdc-typography--display1"
  }, [_vm._v("Whata")]), _vm._v(" "), _c('h2', {
    staticClass: "mdc-typography--display5"
  }, [_vm._v("save the planet - classify water")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72f7e4ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 40
// module chunks = 1